import React from 'react'

import { TRouteOverrides } from 'helpers/applyRouteOverrides'

import { PageId } from 'page-constants'

import { DiscountOfferWrapper } from './pages/DiscountOfferWrapper'

export const AYAHPATH_ROUTES: TRouteOverrides = {
  [PageId.DISCOUNT_OFFER]: <DiscountOfferWrapper />,
}
